import Officeimage from '../images/office.png';
import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

export default function Contactus(){
    const form = useRef();
    const [status, setStatus] = useState('');

    const sendEmail = (e) => {
        e.preventDefault();
        setStatus('sending');

        emailjs
            .sendForm(
                'YOUR_SERVICE_ID', // Replace with your EmailJS service ID
                'YOUR_TEMPLATE_ID', // Replace with your EmailJS template ID
                form.current,
                'YOUR_PUBLIC_KEY' // Replace with your EmailJS public key
            )
            .then(
                (result) => {
                    console.log('SUCCESS!', result.text);
                    setStatus('success');
                    form.current.reset();
                },
                (error) => {
                    console.log('FAILED...', error.text);
                    setStatus('error');
                }
            );
    };

    return (
        <div className="row m-5">
            <div className="col-sm-6">
                <form className="p-3" ref={form} onSubmit={sendEmail}>
                    <p>Make Custom Request</p>
                    <h1 className="contact-header">Tell <span style={{color:"blue"}}>Travel Solutions </span>about your Trip</h1>
                    <div className="row">
                        <div className="col-sm-6 mt-5">
                            <input 
                                type="text" 
                                name="user_name" 
                                placeholder="Fullname" 
                                className="form-control form-control-lg contactDivs" 
                                required 
                            />
                        </div>

                        <div className="col-sm-6 mt-5">
                            <input 
                                type="email" 
                                name="user_email" 
                                placeholder="Email" 
                                className="form-control form-control-lg contactDivs" 
                                required 
                            />
                        </div>   
                    </div>

                    <div className="row">
                        <div className="col-sm-6 mt-5">
                            <input 
                                type="text" 
                                name="budget" 
                                placeholder="Budget" 
                                className="form-control form-control-lg contactDivs" 
                                required 
                            />
                        </div>

                        <div className="col-sm-6 mt-5">
                            <input 
                                type="text" 
                                name="subject" 
                                placeholder="Subject" 
                                className="form-control form-control-lg contactDivs" 
                                required 
                            />
                        </div>   
                    </div>

                    <div className="row mt-5">
                        <div className="col-sm-12">
                            <textarea 
                                name="message" 
                                placeholder="Message" 
                                className="form-control form-control-lg contactDivs"
                                required 
                            />
                        </div> 
                    </div>

                    <div className="row mt-4">
                        <div className="col-sm-4">
                            <button 
                                type="submit" 
                                className="form-control form-control-lg bg-warning"
                                disabled={status === 'sending'}
                            >
                                {status === 'sending' ? 'Sending...' : 'Get a Quote'}
                            </button>
                        </div>
                    </div>

                    {status === 'success' && (
                        <div className="alert alert-success mt-3">
                            Thank you for your message! We'll get back to you soon.
                        </div>
                    )}
                    {status === 'error' && (
                        <div className="alert alert-danger mt-3">
                            Oops! Something went wrong. Please try again later.
                        </div>
                    )}
                </form>
            </div>

            <div className="col-sm-6 bg-light">
                <img src={Officeimage} width="100%" alt="contact" />
            </div>           
        </div>
    );
}

